import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { NoProductMessageComponent } from './no-product-message.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NoProductMessageComponent],
  exports: [NoProductMessageComponent]
})
export class NoProductMessageModule {
}
